function Header() {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <a href="/" className="logo">
            <svg viewBox="0 0 180 40">
              <path d="M10 20 L15 10 L25 10 L30 20 L25 30 L15 30 Z" fill="#ff6b35" stroke="#d4541f" strokeWidth="1.5" />
              <path d="M13 20 L17 13 L23 13 L27 20 L23 27 L17 27 Z" fill="none" stroke="white" strokeWidth="1.5" />
              <circle cx="20" cy="20" r="2" fill="white" />
              <text x="35" y="14" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="bold" fill="white">SECOND HAND</text>
              <text x="35" y="24" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="bold" fill="#ff6b35">ARMORED</text>
              <text x="35" y="32" fontFamily="Arial, sans-serif" fontSize="6" fill="#ccc">.com</text>
            </svg>
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
